// extracted by mini-css-extract-plugin
export default {"poster":"Results_poster__zzedN","grid_container":"Results_grid_container__wEt9L","col":"Results_col__ILRlg"};